import {
  SENDING_CHART_DEVICE_DATA_REQUEST,
  FETCH_CHART_DEVICE_DATA_REQUEST,
  FETCH_CHART_DEVICE_DATA_SUCCESS,
  FETCH_CHART_DEVICE_DATA_FAILURE,
  SENDING_TIME_LINE_DEVICE_DATA_REQUEST,
  FETCH_TIME_LINE_DEVICE_DATA_REQUEST,
  FETCH_TIME_LINE_DEVICE_DATA_SUCCESS,
  FETCH_TIME_LINE_DEVICE_DATA_FAILURE,

  SENDING_POWER_METER_DAY_DATA_REQUEST,
  FETCH_POWER_METER_DAY_DATA_REQUEST,
  FETCH_POWER_METER_DAY_DATA_SUCCESS,
  FETCH_POWER_METER_DAY_DATA_FAILURE,

  SENDING_POWER_METER_MONTH_DATA_REQUEST,
  FETCH_POWER_METER_MONTH_DATA_REQUEST,
  FETCH_POWER_METER_MONTH_DATA_SUCCESS,
  FETCH_POWER_METER_MONTH_DATA_FAILURE
} from '../actions/constants'

const initialState = {
  deviceSelected: {},
  timeQuery: 'day',
  from: '',
  to: '',
  ainChartData: [],
  dinChartData: [],
  powerChartData: [],
  fetching: false,
  error: ''
}

const chart = (state = initialState, action) => {
  switch (action.type) {
    case SENDING_CHART_DEVICE_DATA_REQUEST:
    case SENDING_TIME_LINE_DEVICE_DATA_REQUEST:
    case SENDING_POWER_METER_DAY_DATA_REQUEST:
    case SENDING_POWER_METER_MONTH_DATA_REQUEST:
      return {
        ...state,
        fetching: action.sending
      }
    case FETCH_CHART_DEVICE_DATA_REQUEST:
    case FETCH_TIME_LINE_DEVICE_DATA_REQUEST:
    case FETCH_POWER_METER_DAY_DATA_REQUEST:
    case FETCH_POWER_METER_MONTH_DATA_REQUEST:
      return {
        ...state,
        ainChartData: [],
        dinChartData: [],
        powerChartData: [],
        deviceSelected: action.device,
        timeQuery: action.timeQuery,
        from: action.from,
        to: action.to
      }
    case FETCH_CHART_DEVICE_DATA_SUCCESS:
      return {
        ...state,
        ainChartData: action.chartAIN
      }
    case FETCH_TIME_LINE_DEVICE_DATA_SUCCESS:
      return {
        ...state,
        dinChartData: action.chartDIN
      }
    case FETCH_POWER_METER_DAY_DATA_SUCCESS:
      return {
        ...state,
        powerChartData: action.charPowerDay
      }
    case FETCH_POWER_METER_MONTH_DATA_SUCCESS:
      return {
        ...state,
        powerChartData: action.chartPowerMonth
      }

    case FETCH_CHART_DEVICE_DATA_FAILURE:
    case FETCH_TIME_LINE_DEVICE_DATA_FAILURE:
    case FETCH_POWER_METER_DAY_DATA_FAILURE:
    case FETCH_POWER_METER_MONTH_DATA_FAILURE:
      return {
        ...state,
        error: action.error
      }
    default:
      return state
  }
}

export default chart



// WEBPACK FOOTER //
// ./src/reducers/chart.js